import React, { useEffect, useState } from 'react';
import { AdminLayout } from './AdminDashboard';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import { Card, CardContent } from '../../components/ui/card';
import { Eye, Mail, Phone } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAuthHeader } = useAuth();

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const response = await axios.get(`${API_URL}/admin/bookings`, {
        headers: getAuthHeader()
      });
      setBookings(response.data);
    } catch (error) {
      toast.error('Failed to fetch bookings');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <AdminLayout title="Bookings"><div>Loading...</div></AdminLayout>;

  return (
    <AdminLayout title="Manage Bookings">
      <div className="space-y-6">
        {bookings.length === 0 ? (
          <Card className="border-0 shadow-lg">
            <CardContent className="p-12 text-center">
              <p className="text-gray-600">No bookings yet</p>
            </CardContent>
          </Card>
        ) : (
          <div className="grid gap-6">
            {bookings.map((booking) => (
              <Card key={booking.id} className="border-0 shadow-lg">
                <CardContent className="p-6">
                  <div className="flex justify-between items-start">
                    <div className="space-y-2">
                      <h3 className="text-xl font-semibold text-gray-900">{booking.session_name}</h3>
                      <div className="flex items-center space-x-4 text-sm text-gray-600">
                        <span className="flex items-center">
                          <Mail className="h-4 w-4 mr-2" />
                          {booking.customer_email}
                        </span>
                        {booking.customer_phone && (
                          <span className="flex items-center">
                            <Phone className="h-4 w-4 mr-2" />
                            {booking.customer_phone}
                          </span>
                        )}
                      </div>
                      <div className="text-sm text-gray-600">
                        <p><strong>Name:</strong> {booking.customer_name}</p>
                        <p><strong>Date:</strong> {booking.booking_date}</p>
                        <p><strong>Time:</strong> {booking.booking_time}</p>
                        <p><strong>Booked:</strong> {new Date(booking.created_at).toLocaleDateString()}</p>
                      </div>
                    </div>
                    <div className="text-right space-y-2">
                      <div className="text-2xl font-bold text-sage-700">${booking.price}</div>
                      <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
                        booking.payment_status === 'completed' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-amber-100 text-amber-800'
                      }`}>
                        {booking.payment_status}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminBookings;
